import { CouponButtonType, CouponTagColor } from '../coupon/types';

/** Button样式类型 */
export enum DetailButtonType {
  /** 绿底白字 */
  primary = 'primary',
  /** 灰底绿字 */
  ghost = 'ghost',
  /** 灰底深灰色字 */
  outofperiod = 'outofperiod',
}

/** Button尺寸 */
export enum DetailButtonSize {
  /** 116*56px */
  small = 'small',
  /** 368 * 80px */
  normal = 'normal',
}

/** Button 的props属性 */
export type DetailBtnConfig = {
  /** 是否disabled */
  isDisabled?: boolean;
  /** 是否展示按钮 */
  isShowBtn: boolean;
  /** 按钮文案 */
  btnText: string;
  /** 尺寸，有normal(368*80px)、small(116*56px)两种 */
  size: DetailButtonSize;
  /** 样式类型，有primary(绿底白字)、ghost(灰底绿字)、outofperiod(灰底深灰色字)三种 */
  type: DetailButtonType;
};

/** detail-dialog除了GoodItem以外，所需要的信息 */
export type ExtraDetailInfo = {
  /** 优惠券是否已过期（过期时会将券背景设置为灰色，同时按钮置灰，以及加上邮戳，因此需要设置邮戳文本） */
  isExpire: boolean;
  /** 邮戳文本: coupon-v2.vue右上角用 */
  stampText: string;

  /** 优惠券标签文本: coupon-v2.vue用 */
  couponTagText?: string;
  /** 优惠券标签颜色：coupon-v2.vue用 */
  couponTagColor?: CouponTagColor;
  /** 按钮文本: coupon-v2.vue用；理论上不展示button，如有这种场景，可允许扩展 */
  couponBtnText?: string;
  /** 按钮类型: coupon-v2.vue用，理论上不展示button */
  buttonType?: CouponButtonType,
  /** 优惠券折扣（折）: coupon-v2.vue用 */
  prizeDiscount?: number;
  /** 是否连锁券: coupon-v2.vue用，默认false */
  isChain?: boolean;
  /** 是否展示层叠阴影: coupon-v2.vue用 */
  isShowShadow?: boolean;
  /** 优惠券提示条文本 - 右侧: coupon-v2.vue用 */
  tipsTextRight?: string;
  /** 优惠券挖空半圆颜色: coupon-v2.vue用 */
  semicircleColor?: string;
  /** 券包-金额下方文案：coupon-v2.vue用 */
  pkgInfo?: string;
  /** 主題券 logo */
  themeLogo?: string;
};
